<template>
  <div v-if="showMenu">
    <div v-if="can.config" class="mb-4">
      <inertia-link
        class="flex items-center py-3 group"
        :href="route('admin')">
        <icon
          name="cogs"
          class="mr-2 w-4 h-4"
          :class="
            isUrl('admin')
              ? 'fill-white'
              : 'fill-indigo-400 group-hover:fill-white'
          " />
        <div
          :class="
            isUrl('admin')
              ? 'text-white'
              : 'text-indigo-300 group-hover:text-white'
          ">
          Admin Config
        </div>
      </inertia-link>
    </div>
    <div class="mb-4">
      <inertia-link
        class="flex items-center py-3 group"
        :href="route('dashboard')">
        <icon
          name="dashboard"
          class="mr-2 w-4 h-4"
          :class="
            isUrl('') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'
          " />
        <div
          :class="
            isUrl('') ? 'text-white' : 'text-indigo-300 group-hover:text-white'
          ">
          Dashboard
        </div>
      </inertia-link>
    </div>
    <div v-if="can.list_users" class="mb-4">
      <inertia-link class="flex items-center py-3 group" :href="route('users')">
        <icon
          name="users"
          class="mr-2 w-4 h-4"
          :class="
            isUrl('users')
              ? 'fill-white'
              : 'fill-indigo-400 group-hover:fill-white'
          " />
        <div
          :class="
            isUrl('users')
              ? 'text-white'
              : 'text-indigo-300 group-hover:text-white'
          ">
          Users
        </div>
      </inertia-link>
    </div>
    <div v-if="can.list_mahasiswa" class="mb-4">
      <inertia-link
        class="flex items-center py-3 group"
        :href="route('mahasiswa')">
        <icon
          name="users"
          class="mr-2 w-4 h-4"
          :class="
            isUrl('mahasiswa')
              ? 'fill-white'
              : 'fill-indigo-400 group-hover:fill-white'
          " />
        <div
          :class="
            isUrl('mahasiswa')
              ? 'text-white'
              : 'text-indigo-300 group-hover:text-white'
          ">
          Mahasiswa
        </div>
      </inertia-link>
    </div>
    <div v-if="role === 'MAHASISWA'" class="mb-4">
      <inertia-link
        class="flex items-center py-3 group"
        :href="route('mahasiswa.edit.self')">
        <icon
          name="id-card"
          class="mr-2 w-4 h-4"
          :class="
            isUrl('mahasiswa/edit')
              ? 'text-white'
              : 'text-indigo-400 group-hover:fill-white'
          " />
        <div
          :class="
            isUrl('mahasiswa/edit')
              ? 'text-white'
              : 'text-indigo-300 group-hover:text-white'
          ">
          Biodata
        </div>
      </inertia-link>
    </div>
    <div v-if="can.jenjang_pendidikan" class="mb-4">
      <inertia-link
        class="flex items-center py-3 group"
        :href="route('jenjang_pendidikan.index')">
        <icon
          name="jenjang-pendidikan"
          class="mr-2 w-4 h-4"
          :class="
            isUrl('jenjang_pendidikan')
              ? 'text-white'
              : 'text-indigo-400 group-hover:fill-white'
          " />
        <div
          :class="
            isUrl('jenjang_pendidikan')
              ? 'text-white'
              : 'text-indigo-300 group-hover:text-white'
          ">
          Kelola Jenjang Pendidikan
        </div>
      </inertia-link>
    </div>
    <div v-if="can.list_universitas" class="mb-4">
      <inertia-link
        class="flex items-center py-3 group"
        :href="route('universitas.index')">
        <icon
          name="universitas"
          class="mr-2 w-4 h-4"
          :class="
            isUrl('universitas')
              ? 'text-white'
              : 'text-indigo-400 group-hover:fill-white'
          " />
        <div
          :class="
            isUrl('universitas')
              ? 'text-white'
              : 'text-indigo-300 group-hover:text-white'
          ">
          Universitas
        </div>
      </inertia-link>
    </div>
    <div v-if="can.list_bank" class="mb-4">
      <inertia-link
        class="flex items-center py-3 group"
        :href="route('bank.index')">
        <icon
          name="store-front"
          class="mr-2 w-4 h-4"
          :class="
            isUrl('bank')
              ? 'fill-white'
              : 'fill-indigo-400 group-hover:fill-white'
          " />
        <div
          :class="
            isUrl('bank')
              ? 'text-white'
              : 'text-indigo-300 group-hover:text-white'
          ">
          Bank
        </div>
      </inertia-link>
    </div>
    <div v-if="can.list_distrik" class="mb-4">
      <inertia-link
        class="flex items-center py-3 group"
        :href="route('distrik.index')">
        <icon
          name="location"
          class="mr-2 w-4 h-4"
          :class="
            isUrl('distrik')
              ? 'fill-white'
              : 'fill-indigo-400 group-hover:fill-white'
          " />
        <div
          :class="
            isUrl('distrik')
              ? 'text-white'
              : 'text-indigo-300 group-hover:text-white'
          ">
          Distrik
        </div>
      </inertia-link>
    </div>
    <div v-if="can.list_kota_studi" class="mb-4">
      <inertia-link
        class="flex items-center py-3 group"
        :href="route('kota_studi.index')">
        <icon
          name="office"
          class="mr-2 w-4 h-4"
          :class="
            isUrl('kota-studi')
              ? 'fill-white'
              : 'fill-indigo-400 group-hover:fill-white'
          " />
        <div
          :class="
            isUrl('kota-studi')
              ? 'text-white'
              : 'text-indigo-300 group-hover:text-white'
          ">
          Kota Studi
        </div>
      </inertia-link>
    </div>
    <template v-if="can.krs && verificationStatus.id === 3">
      <div class="mb-4">
        <inertia-link
          class="flex items-center py-3 group"
          :href="route('mahasiswa.krs.index')">
          <icon
            name="krs"
            class="mr-2 w-4 h-4"
            :class="
              isUrl('krs')
                ? 'text-white'
                : 'text-indigo-400 group-hover:fill-white'
            " />
          <div
            :class="
              isUrl('krs')
                ? 'text-white'
                : 'text-indigo-300 group-hover:text-white'
            ">
            KRS & KHS
          </div>
        </inertia-link>
      </div>
      <div class="mb-4">
        <inertia-link
          class="flex items-center py-3 group"
          :href="route('mahasiswa.payment_info.index')">
          <icon
            name="payment"
            class="mr-2 w-4 h-4"
            :class="
              isUrl('payment_info')
                ? 'text-white'
                : 'text-indigo-400 group-hover:fill-white'
            " />
          <div
            :class="
              isUrl('payment_info')
                ? 'text-white'
                : 'text-indigo-300 group-hover:text-white'
            ">
            Info Pembayaran
          </div>
        </inertia-link>
      </div>
    </template>
    <template v-if="can.verify_krs">
      <div class="mb-4">
        <inertia-link
          class="flex items-center py-3 group"
          :href="urlIndexVerifyKRS">
          <icon
            name="krs"
            class="mr-2 w-4 h-4"
            :class="
              isUrl('student_reports')
                ? 'text-white'
                : 'text-indigo-400 group-hover:fill-white'
            " />
          <div
            :class="
              isUrl('student_reports')
                ? 'text-white'
                : 'text-indigo-300 group-hover:text-white'
            ">
            KRS & KHS
          </div>
        </inertia-link>
      </div>
      <div class="mb-4">
        <inertia-link
          class="flex items-center py-3 group"
          :href="route('payment.index')">
          <icon
            name="payment"
            class="mr-2 w-4 h-4"
            :class="
              isUrl('payment')
                ? 'text-white'
                : 'text-indigo-400 group-hover:fill-white'
            " />
          <div
            :class="
              isUrl('payment')
                ? 'text-white'
                : 'text-indigo-300 group-hover:text-white'
            ">
            Pembayaran
          </div>
        </inertia-link>
      </div>
    </template>
    <div v-if="can.eos" class="mb-4">
      <inertia-link
        class="flex items-center py-3 group"
        :href="route('eos.index')">
        <icon
          name="eos"
          class="mr-2 w-4 h-4"
          :class="
            isUrl('eos')
              ? 'text-white'
              : 'text-indigo-400 group-hover:fill-white'
          " />
        <div
          :class="
            isUrl('eos')
              ? 'text-white'
              : 'text-indigo-300 group-hover:text-white'
          ">
          Akhir Studi
        </div>
      </inertia-link>
    </div>
    <div v-if="can.eos_payment" class="mb-4">
      <inertia-link
        class="flex items-center py-3 group"
        :class="
          isUrl('eos_payment')
            ? 'text-white'
            : 'text-indigo-300 group-hover:text-white'
        "
        :href="route('eos_payment.index')">
        <icon
          name="eos-payment"
          class="mr-2 w-4 h-4"
          :class="
            isUrl('eos_payment')
              ? 'text-white'
              : 'text-indigo-300 group-hover:text-white'
          " />
        <div>Pembayaran Akhir Studi</div>
      </inertia-link>
    </div>
    <div v-if="role !== 'GUEST'" class="mb-4">
      <inertia-link
        class="flex items-center py-3 group"
        :href="route('download_files.index')">
        <icon
          name="download-files"
          class="mr-2 w-4 h-4"
          :class="
            isUrl('download_files')
              ? 'text-white'
              : 'text-indigo-400 group-hover:fill-white'
          " />
        <div
          :class="
            isUrl('download_files')
              ? 'text-white'
              : 'text-indigo-300 group-hover:text-white'
          ">
          Files
        </div>
      </inertia-link>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import { Link } from '@inertiajs/vue2'

export default {
  components: {
    Icon,
    'inertia-link': Link,
  },
  computed: {
    can () {
      return this.$page.props.auth.user.can
    },
    role () {
      return this.$page.props.auth.user.role
    },
    verificationStatus () {
      return this.$page.props.auth.user.mahasiwa_verification_status
    },
    urlIndexVerifyKRS () {
      return `/student_reports?scholarship_year=${this.$page.props.scholarship_year}&scholarship_period=${this.$page.props.scholarship_period}`
    },
    showMenu () {
      if (this.role === 'MAHASISWA') return this.verificationStatus != null
      else return true
    },
  },
  methods: {
    isUrl (...urls) {
      const currentUrl = window.location.pathname.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls[0] === currentUrl
    },
  },
}
</script>
